import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class BatchAllocateService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL V5: F7004 pattern - Accept filterParams and rowData parameters
  runBatchAllocate(
    baseUrl: string,
    settings: any,
    data: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🚀 CRITICAL: Use correct URL construction (baseUrl contains /gtw/)
    const url = `${baseUrl}/saveJsonObject?action_code=jc0gvf`;

    // 🚀 CRITICAL V5: Build AngularJS-compatible payload structure (F7004 pattern)
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Add JSON objects as strings (following original service pattern)
    const jsonSettings = JSON.stringify(settings);
    const jsonObj = JSON.stringify(data);
    
    params = _.extend({ clob_settings: jsonSettings }, params);
    params = _.extend({ clob_data: jsonObj }, params);
    
    // 🚀 CRITICAL V5: Use real rowData values (NOT hardcoded)
    params.tax_year = rowData?.TAX_YEAR || filterParams?.tax_year || settings?.tax_year;
    params.scenario = rowData?.SCENARIO || filterParams?.scenario || settings?.scenario;
    params.jcd_key = rowData?.JCD_KEY || globalService?.jcd_key || settings?.jcd_key;
    params.process_name = 'Run Batch Allocate';
    params.sso_id = settings?.sso_id;

    // 🚀 CRITICAL V5: Build checkLockedbj from rowData (NOT hardcoded) - F7004 pattern
    const checkLockedbj = [{
      // "leid": rowData?.LEID || rowData?.SOURCE_LEID,
      // "cdr_number": rowData?.CDR_NO || rowData?.TAX_CODE,
      // "consol_group_key": String(rowData?.CONSOL_GROUP_KEY || ''),
      // "reporting_period": String(rowData?.REPORTING_PERIOD || ''),
      "combination_key": String(rowData?.COMBINATION_KEY || ''),
      // "scenario_key": parseInt(filterParams?.scenario || 74)
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    params.is_issue_key_enabled = 'N';
    params.scenarioCode = 'RAF';

    // Add other required fields from rowData
    if (filterParams?.CONSOL_GROUP_KEY) {
      params.filing_key = filterParams.CONSOL_GROUP_KEY;
    }

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        urlEncoded.set(key, params[key]);
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}